export const allAddonsTypes = {
  ADDON_COMPETITOR: 'competitor',
  ADDON_TRACKEDKEYWORDS: 'trackedkeywords',
  ADDON_USER: 'user',
  ADDON_DAILYSEARCH: 'dailysearch',
  ADDON_DOMAIN: 'domain',
  ADDON_KEYWORD_METRICS_UPDATES: 'keyword_metrics_updates',
  ADDON_AIW_BLOGGER: 'aiw_blogger',
  ADDON_AIW_BUSINESS: 'aiw_business',
  ADDON_AIW_SHAKESPEARE: 'aiw_shakespeare',
}
